// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__19UtY","col":"styles_col__2DMNT"};